module.exports = __webpack_public_path__ + "static/media/cricket.c36cb67f.svg";